import pythonApiClient from "./pythonBaseApi";

const reservaManualCamasApi = {
  /**
   * Validar archivo Excel de reserva manual de camas
   * @param {File} file - Archivo Excel con columnas DNI, Zona, Módulo, Habitación, Cama
   * @param {number} proyectoId - ID del proyecto
   * @returns {Promise} Respuesta de validación
   */
  validateFile: (file, proyectoId) => {
    const formData = new FormData();
    formData.append("file", file);
    
    return pythonApiClient.post(
      "/procesos/hoteleria/reserva-manual-camas/validate",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-Proyecto-ID": proyectoId,
        },
      }
    );
  },

  /**
   * Procesar reserva manual de camas desde archivo Excel
   * @param {File} file - Archivo Excel con columnas DNI, Zona, Módulo, Habitación, Cama
   * @param {number} proyectoId - ID del proyecto
   * @returns {Promise} Resultado del procesamiento
   */
  procesarReservas: (file, proyectoId) => {
    const formData = new FormData();
    formData.append("file", file);
    
    return pythonApiClient.post(
      "/procesos/hoteleria/reserva-manual-camas",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-Proyecto-ID": proyectoId,
        },
      }
    );
  },

  /**
   * Buscar trabajadores por documento o nombre/apellidos
   * @param {string} busqueda - Texto a buscar
   * @param {number} proyectoId - ID del proyecto
   * @returns {Promise} Lista de trabajadores encontrados
   */
  buscarTrabajadores: (busqueda, proyectoId) => {
    return pythonApiClient.get(
      "/procesos/hoteleria/reserva-manual-camas/buscar-trabajadores",
      {
        params: { busqueda },
        headers: {
          "X-Proyecto-ID": proyectoId,
        },
      }
    );
  },

  /**
   * Crear reserva manual individual de cama para un trabajador
   * @param {number} trabajadorId - ID del trabajador
   * @param {string} zonaNombre - Nombre de la zona
   * @param {string} moduloNombre - Nombre del módulo
   * @param {string} habitacionNumero - Número de la habitación
   * @param {string} camaCodigo - Código/número de la cama
   * @param {number} proyectoId - ID del proyecto
   * @param {{ fechaInicioEstadia: string, fechaFinEstadia: string }} fechas - Fechas obligatorias YYYY-MM-DD
   * @returns {Promise} Resultado de la reserva
   */
  crearReservaIndividual: (
    trabajadorId,
    zonaNombre,
    moduloNombre,
    habitacionNumero,
    camaCodigo,
    proyectoId,
    fechas = {}
  ) => {
    const formData = new FormData();
    formData.append("trabajador_id", trabajadorId);
    formData.append("zona_nombre", zonaNombre);
    formData.append("modulo_nombre", moduloNombre);
    formData.append("habitacion_numero", habitacionNumero);
    formData.append("cama_codigo", camaCodigo);
    if (fechas.fechaInicioEstadia) {
      formData.append("fecha_inicio_estadia", fechas.fechaInicioEstadia);
    }
    if (fechas.fechaFinEstadia) {
      formData.append("fecha_fin_estadia", fechas.fechaFinEstadia);
    }

    return pythonApiClient.post(
      "/procesos/hoteleria/reserva-manual-camas/reserva-individual",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-Proyecto-ID": proyectoId,
        },
      }
    );
  },
};

export default reservaManualCamasApi;
